var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatWeDoHomeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    zoomAndPan: "magnify",
    viewBox: "0 0 300 299.999988",
    height: 400,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "774fab3c88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32 102 L 295.5 102 L 295.5 198 L 32 198 Z M 32 102 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9f9f9f",
    d: "M 56.855469 185.660156 L 47.070312 192.59375 C 38.144531 198.914062 32.023438 201.566406 18.832031 178.253906 L 13.335938 168.589844 C 0.148438 145.25 4.9375 140.195312 13.839844 133.898438 L 23.636719 126.964844 Z M 56.855469 185.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#774fab3c88)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9f9f9f",
    d: "M 293.136719 132.308594 C 294.710938 135.238281 295.433594 138.703125 295.089844 141.898438 C 294.6875 145.710938 292.890625 148.503906 291.339844 149.023438 L 188.789062 195.640625 C 173.914062 200.476562 150.480469 192.515625 129.804688 185.488281 C 112.234375 179.515625 97.058594 174.347656 87.824219 177.425781 L 65.710938 181.503906 L 32.113281 122.160156 L 61.769531 108.664062 C 84.476562 98.304688 98.140625 103.496094 120.785156 112.089844 C 134.648438 117.359375 151.914062 123.882812 175.863281 128.386719 C 195.582031 132.09375 201.382812 145.378906 202.703125 149.363281 C 204.292969 154.207031 204.046875 158.921875 202.09375 161.367188 C 199.984375 163.972656 198.71875 163.914062 188.554688 160.910156 C 186.851562 160.414062 184.992188 159.859375 182.925781 159.289062 C 182.625 159.210938 182.316406 159.171875 181.992188 159.152344 L 136.621094 156.796875 C 133.976562 156.660156 131.808594 159 131.796875 162.023438 C 131.796875 165.027344 133.933594 167.59375 136.578125 167.730469 L 181.488281 170.0625 C 183.3125 170.582031 184.992188 171.058594 186.507812 171.515625 C 196.578125 174.488281 203.21875 176.464844 209.285156 168.976562 C 212.484375 164.957031 213.804688 159.117188 213.152344 152.820312 L 282.914062 126.113281 C 285.59375 125.292969 288.8125 126.617188 291.320312 129.601562 C 292.007812 130.441406 292.621094 131.359375 293.132812 132.335938 L 293.132812 132.308594 Z M 293.136719 132.308594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatWeDoHomeLogo);
export default __webpack_public_path__ + "static/media/what-we-do-home-logo.a9eb1273b6fc96b929d03c9d9966da54.svg";
export { ForwardRef as ReactComponent };